export default {
  errors: (state) => state.errors,
  success: (state) => state.success,
  coops: (state) => state.coops,
  next_coops_url: (state) => state.next_coops_url,
  search_keyword: (state) => state.search_keyword,
  search_station: (state) => state.search_station,
};
